<template>
  <v-dialog
    title="Batch Add"
    :visible.sync="dialogVisible"
    :scrollbar="false"
    width="auto"
    @closed="onClosed"
  >
    <div class="item">
      <div class="mr10">1.Please download User List and Template firstly.</div>
      <el-button type="primary" icon="el-icon-download" @click="exportMSLList">
        User List
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-download"
        @click="downloadTemplate"
      >
        Import Template
      </el-button>
    </div>
    <div class="item">
      <div class="mr10">2.Fill the data into template and upload it.</div>
      <div class="el-uploader-wrap">
        <div class="el-uploader-inner">
          <div class="el-uploader">
            <input
              class="upload-input"
              ref="upload"
              type="file"
              accept=".xlsx,.xls"
              @change="handleChange"
            />
            <div @click="$refs.upload.click()">
              <el-input
                disabled
                :value="fileName"
                placeholder="Please select file"
              >
                <el-button class="append-button" slot="append" type="text">
                  {{ buttonLabel }}
                </el-button>
              </el-input>
            </div>
          </div>
          <el-button type="primary" @click="handleSubmit" :disabled="disabled">
            Upload
          </el-button>
        </div>
        <div class="upload-progress">
          <el-progress
            v-if="showProgress"
            :percentage="percentage"
            :status="status"
            :show-text="false"
            :stroke-width="3"
          />
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import downloadjs from "downloadjs";
export default {
  name: "batch-add-dialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      selectFile: null,
      showProgress: false,
      percentage: 0,
      status: "success",
      disabled: true,
    };
  },
  computed: {
    buttonLabel() {
      return this.selectFile ? "Reselect file" : "Select File";
    },
    fileName() {
      return this.selectFile ? this.selectFile.name : "";
    },
    role() {
      return this.$store.state.role;
    },
    templateUrl() {
      if (this.role === "RoleCode.Admin") {
        return "/template/SEUserImportTemplate.xlsx";
      } else {
        return "/template/SupSEUserImportTemplate.xlsx";
      }
    },
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    onClosed() {
      Object.assign(this.$data, this.$options.data());
    },
    downloadTemplate() {
      this.axios
        .get(this.templateUrl, {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            `HCP_Import_Template.xlsx`,
            "application/vnd.ms-excel"
          );
          this.$message.success(`Download template successful!`);
        });
    },
    exportMSLList() {
      const msg = this.$message({
        message: `User list is exporting...`,
        duration: 0,
      });
      this.axios
        .get(`/user/exportUserList`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = `Export User list successful!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = `Export User list failure!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    handleChange(e) {
      const file = e.target.files[0];
      this.$refs.upload.value = "";
      if (!/\.(?:xlsx|xls})$/i.test(file.name)) {
        this.$message.warning("Only xlsx file can be uploaded");
        return;
      }
      this.showProgress = false;
      this.percentage = 0;
      this.status = "success";
      this.selectFile = file;
      this.disabled = false;
    },
    handleSubmit() {
      if (this.selectFile) {
        this.status = "success";
        this.disabled = true;
        let formData = new FormData();
        formData.append("file", this.selectFile, this.selectFile.name);
        this.axios
          .post("/se/importSe", formData, {
            header: {
              headers: { "Content-Type": "multipart/form-data" },
            },
            onUploadProgress: (e) => {
              if (e.lengthComputable) {
                this.showProgress = true;
                this.percentage = ((e.loaded / e.total) * 100) | 0;
              }
            },
          })
          .then(({ code, msg, data }) => {
            if (code == 200) {
              this.showProgress = false;
              this.$message.success("Upload template successfully");
              setTimeout(() => {
                this.$emit("success", data);
                console.log(data);
                this.onClosed();
              }, 1000);
            } else {
              this.disabled = false;
              this.$message.error(msg);
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 10px 15px 15px !important;
  }
  .el-dialog__footer {
    padding: 0;
  }
}
.el-uploader-wrap {
  padding-top: 14px;
  .el-uploader-inner {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }
}
.el-uploader {
  position: relative;
  margin-right: 10px;
  .upload-input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    cursor: pointer;
    -webkit-appearance: none;
    display: none;
  }
  .el-input + .el-button {
    margin-left: 5px;
  }
  .el-input {
    ::v-deep {
      .el-input__inner {
        cursor: pointer;
        background: none;
        border-right-width: 0;
        color: #606266;
      }
      .el-input-group__append {
        background: none;
      }
    }
  }
  .append-button {
    padding-right: 10px;
    color: $theme-color;
  }
}
.upload-progress {
  height: 8px;
}
.item {
  display: flex;
  align-items: center;
  color: #606266;
  margin-bottom: 10px;
}
.mr10 {
  margin-right: 15px;
}
</style>
